import React, { useState, useEffect, Fragment, useRef } from "react";
import { setup } from "goober";
import "../MultiStep/MultiStep.scss";
import { withTranslation } from "react-i18next";
import CancelContractModal from "../CancelContractModal";
import StepOne from "../MultiStep/StepOne";
import StepTwo from "../MultiStep/StepTwo";
import StepThree from "../MultiStep/StepThree";
import StepFour from "../MultiStep/StepFour";
import StepFive from "../MultiStep/StepFive";
import StepSix from "../MultiStep/StepSix";
import * as moment from "moment";
import { useHistory } from "react-router-dom";
import { stripHtml } from "utils/sanitize";
import {
  useGetContractTemplateMutation,
  useUploadContractMutation,
  getContractTemplatePdf,
  useEditContractMutation,
  useContractTemplateMutation,
} from "repositories/contract-repository";
import toast from "react-hot-toast";
import constants from "../../../../../constants";
import PreviewPersonnelContract from "../PreviewPersonnelContract";
import PreviewAssociateContract from "../PreviewAssociateContract";
import Loader from "components/Loader";
import ConfirmContractModal from "../ConfirmContractModal";
import ExportContractModal from "../ExportContractModal";
import SaveTemplateModal from "../SaveTemplateModal";
import { cloneDeep } from "lodash";
import {
  b64toBlob,
  encodeId,
  getCacheLocalstorage,
  isMobileTab,
  isValidDate,
  normalizeContractDetailsDatesForApi,
  parseCalendarDateToLocalDate,
} from "utils";
import FileSaver from "file-saver";
export const maxLimitReach = 80000;
setup(React.createElement);
const getStep = (defaultIndex, newIndex, length) => {
  if (newIndex <= length) {
    return newIndex;
  }
  return defaultIndex;
};

export const replaceableValue = [
  { key: "BusinessLegalName", text: "[Office Name]" },
  { key: "OfficeAddress", text: "[Office Address]" },
  { key: "Date", text: "[Date of Contract]" },
  { key: "StartOfWorkDate", text: "[Start Date]" },
  { key: "EndOfWorkDate", text: "[End Date]" },
  { key: "LengthOfEmployment", text: "[Length Of Employment]" },
  { key: "Position", text: "[Position]" },
  { key: "EmployeeName", text: "[Employee Name]" },
  { key: "EmployeeAddress", text: "[Employee Address]" },
  { key: "Salary", text: "[Salary/Fee/Wage]" },
  { key: "commission", text: "[Commission Amount or %]" },
  { key: "bonus", text: "[Performance Bonus details or amount]" },
];

export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};

export const replaceAll = (str, find, replace) => {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
};

export const addDataIntoContractArray = ({
  BasicDetails,
  officeDetail,
  setDisplayData,
}) => {
  const contractData = JSON.parse(JSON.stringify(BasicDetails.ContractDetails));
  if (contractData) {
    const displayData = contractData.map((e) => {
      replaceableValue.forEach((val) => {
        if (e.text != "" && e.text != null && BasicDetails[val.key]) {
          if (val.key.includes("Date")) {
            e.text = replaceAll(
              e.text,
              val.text,
              moment(BasicDetails[val.key]).format("DD-MM-YYYY"),
            );
          } else {
            e.text = replaceAll(e.text, val.text, BasicDetails[val.key]);
          }
        }
      });
      if (
        e.text != "" &&
        e.text != null &&
        e.text.includes("[Account Owner Name]")
      ) {
        let name = officeDetail
          ? officeDetail.owner.firstName + " " + officeDetail.owner.lastName
          : "";
        e.text = replaceAll(e.text, "[Account Owner Name]", name);
      }
      return e;
    });
    setDisplayData(displayData);
  }
};

const getTopNavStyles = (indx, length) => {
  const styles = [];
  for (let i = 0; i < length; i++) {
    if (i < indx) {
      styles.push("done");
    } else if (i === indx) {
      styles.push("doing");
    } else {
      styles.push("todo");
    }
  }
  return styles;
};

const getButtonsState = (indx, length) => {
  if (indx > 0 && indx < length - 1) {
    return {
      showPreviousBtn: true,
      showNextBtn: true,
      showCompleteBtn: false,
    };
  } else if (indx === 0) {
    return {
      showPreviousBtn: false,
      showNextBtn: true,
      showCompleteBtn: false,
    };
  } else {
    return {
      showPreviousBtn: true,
      showNextBtn: false,
      showCompleteBtn: true,
    };
  }
};

function AddContract({ officeId, staffId, officeDetail, t, ...props }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [confirmSentModal, setConfirmSentModal] = useState(false);
  const [confirmExportModal, setConfirmExportModal] = useState(false);
  const [saveContractTemplateModal, setSaveContractTemplateModal] =
    useState(false);

  const designationType = localStorage.getItem("designation")
    ? +localStorage.getItem("designation")
    : 2;
  const isPerSonnelType = designationType === 1;
  const steps = designationType !== 1 ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4];
  const [fieldList, setfieldList] = useState([]);
  const [previewContract, setPreviewContract] = useState(false);
  const [showPrompt, setShowPrompt] = useState(true);
  const stateRef = useRef();

  const [pdfLoader, setPdfLoader] = useState(false);
  const [contractId, setContractId] = useState(0);
  const [BasicDetails, setBasicDetails] = useState(() => {
    const values = getCacheLocalstorage(
      constants.contracts.contractslocalstorageKey,
      true,
    );
    return {
      staffId,
      IsSubmitted: false,
      Type: 2,
      Date: moment().toDate(),
      BusinessLegalName: officeDetail ? officeDetail.name : "",
      Position:
        values?.designation && values?.designation?.title
          ? values?.designation?.title
          : "",
      OfficeAddress: officeDetail ? officeDetail?.address : "",
      LengthOfEmployment: "",
      StartOfWorkDate: values?.staffContractEmploymentDate
        ? parseCalendarDateToLocalDate(values?.staffContractEmploymentDate) ||
          moment().toDate()
        : moment().toDate(),
      EndOfWorkDate: null,
      EmployeeName: values?.staffName || "",
      EmployeeAddress: values?.address || "",
      Salary: values?.annualSalary
        ? values?.annualSalary?.toString() + " " + t("staff.cad")
        : "",
      ContractDetails: [],
      commission: values?.commission
        ? values?.commission +
          " " +
          (values.commissionType === 1 ? t("staff.percentage") : t("staff.cad"))
        : "",
      bonus: values?.bonus
        ? values?.bonus +
          " " +
          (values.bonusType === 1 ? t("staff.percentage") : t("staff.cad"))
        : "",
    };
  });
  stateRef.current = BasicDetails;
  const [isSavedTemplate, setisSavedTemplate] = useState("false");
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [contractTemplateData, setcontractTemplateData] = useState([]);
  const getContractTemplateMutation = useGetContractTemplateMutation();

  useEffect(() => {
    if (officeDetail) {
      setBasicDetails((e) => ({
        ...e,
        BusinessLegalName: officeDetail ? officeDetail.name : "",
        OfficeAddress: officeDetail ? officeDetail?.address : "",
      }));
    }
  }, [officeDetail]);

  useEffect(() => {
    if (isSavedTemplate === "false" && !pdfLoader && officeDetail) {
      fetchTemplateData();
      setSelectedTemplateId(null);
    }

    // eslint-disable-next-line
  }, [isSavedTemplate, officeDetail]);
  const fetchTemplateData = async (ContractTemplateNameId) => {
    if (
      ContractTemplateNameId &&
      selectedTemplateId?.id === ContractTemplateNameId?.id
    ) {
      return true;
    }
    setPdfLoader(true);
    if (ContractTemplateNameId) {
      setSelectedTemplateId(ContractTemplateNameId);
    }
    try {
      const resp = await getContractTemplateMutation.mutateAsync({
        officeId,
        isSavedTemplate,
        designationType,
        ContractTemplateNameId: ContractTemplateNameId?.id,
      });
      if (resp && resp.length) {
        setcontractTemplateData(resp);
        let tempData = JSON.parse(JSON.stringify(resp));

        tempData = tempData.map((e) => {
          switch (e.title) {
            case "Account Owner Name Inc.":
              e.text = officeDetail
                ? officeDetail.owner.firstName +
                  " " +
                  officeDetail.owner.lastName
                : "";

              break;
            case "Date":
              const day = isValidDate(e.text);
              if (day) {
                const localDate =
                  parseCalendarDateToLocalDate(e.text) ||
                  moment(e.text).toDate();
                // Store date-only string so JSON/API never UTC-shifts the day
                e.text = moment(localDate).format("DD-MM-YYYY");
              } else {
                e.text = moment().format("DD-MM-YYYY");
              }
              break;
            case "Authorised Signature":
              if (
                !!e.text &&
                e.text.split(
                  `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/`,
                )[1]
              ) {
                e.text =
                  `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/` +
                  e.text.split(
                    `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/`,
                  )[1];
              }
              break;
            default:
              break;
          }
          return e;
        });

        setBasicDetails((e) => ({ ...e, ContractDetails: tempData }));
        setPdfLoader(false);
        return true;
      } else {
        setPdfLoader(false);
        toast.error(t("contracts.noRecentTemplate"));
        setisSavedTemplate("false");
      }
    } catch (e) {
      setPdfLoader(false);
      toast.error(t("contracts.noRecentTemplate"));
      setisSavedTemplate("false");
      if (ContractTemplateNameId) {
        setSelectedTemplateId(null);
      }
    }
  };

  const showNav =
    typeof props.showNavigation === "undefined" ? true : props.showNavigation;
  const [activeStep] = useState(getStep(0, props.activeStep, steps.length));
  const [stylesState, setStyles] = useState(
    getTopNavStyles(activeStep, steps.length),
  );
  const [compState, setComp] = useState(activeStep);
  const [buttonsState, setButtons] = useState(
    getButtonsState(activeStep, steps.length),
  );
  const uploadContractMutation = useUploadContractMutation();
  const editContractMutation = useEditContractMutation();
  const contractTemplateMutation = useContractTemplateMutation();
  const [errors, seterrors] = useState({});
  const history = useHistory();

  const [contractFormDisplayData, setDisplayData] = useState([]);
  useEffect(() => {
    getContractList();
    addDataIntoContractArray({
      BasicDetails,
      officeDetail,
      setDisplayData,
    });
    if (showPrompt) {
      history.block(() => {
        setModalIsOpen(true);
        return false;
      });
    } else {
      history.block(() => {});
    }

    return () => {
      history.block(() => {});
    };
    // eslint-disable-next-line
  }, [BasicDetails, history, showPrompt]);

  const setStepState = (indx) => {
    setStyles(getTopNavStyles(indx, steps.length));
    setComp(indx < steps.length ? indx : compState);
    setButtons(getButtonsState(indx, steps.length));
  };
  const scrollToError = () => {
    setTimeout(() => {
      const error = document.getElementsByClassName("error-msg");
      if (error && error.length) {
        error[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }, 1000);
  };
  const incereaseStateAndScrollToZero = () => {
    setStepState(compState + 1);
    window.scrollTo(0, 0);
  };
  const next = (saveAsDrafCheck) => {
    const checkSaveAsDraft = saveAsDrafCheck === true;
    if (compState === 0) {
      if (isValidStepOne()) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 1) {
      if (isValidStep(2)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 2) {
      if (isValidStep(3)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 3) {
      if (isValidStep(4)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
          if (isPerSonnelType) {
            setPreviewContract(true);
          }
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 4) {
      if (isValidStep(5)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 5) {
      if (isValidStep(6)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
          setPreviewContract(true);
        }
        return true;
      } else {
        scrollToError();
      }
    } else {
      if (!checkSaveAsDraft) {
        setStepState(compState + 1);
      }
      return true;
    }
  };
  const previous = () => {
    if (previewContract) {
      setPreviewContract(false);
    } else {
      setStepState(compState > 0 ? compState - 1 : compState);
    }
  };

  const renderSteps = () =>
    steps.map((s, i) => {
      if (stylesState[i] === "todo") {
        return (
          <li className={"todo-list "} key={i} value={i}>
            <span>{i + 1}</span>
          </li>
        );
      } else if (stylesState[i] === "doing") {
        return (
          <li className={"doing-list "} key={i} value={i}>
            <span>{i + 1}</span>
          </li>
        );
      } else {
        return (
          <li className={"done-list "} key={i} value={i}>
            <span>{i + 1}</span>
          </li>
        );
      }
    });

  const isValidStep = (step) => {
    const newArr = cloneDeep(stateRef.current.ContractDetails);
    const isValid = !newArr
      .filter((e) => e.isActive && e.stepNumber === step)
      .some((e) => {
        if (e.isHtmlContent) {
          if (!removeHtmlChar(e.text)) {
            e.error = t("form.errors.emptyField", { field: e.title });
            return true;
          } else if (removeHtmlChar(e.text).length > maxLimitReach) {
            e.error = t("form.errors.maxLimit", {
              limit: maxLimitReach.toString(),
            });
            return true;
          } else {
            return false;
          }
        } else {
          if (e.text == "" || e.text == null) {
            if (e.title == "Authorised Signature") {
              e.error = t("form.errors.imageUpload");
            } else {
              e.error = t("form.errors.emptyField", { field: e.title });
            }
          }
        }
        return e.text == "" || e.text == null;
      });

    setBasicDetails((prevState) => ({ ...prevState, ContractDetails: newArr }));
    return isValid;
  };

  const isValidStepOne = () => {
    let isValid = true;
    const errorsCopy = cloneDeep(errors);
    let BasicDetailsCopy = stateRef.current;
    isValid = isValidStep(1);
    if (isSavedTemplate == "true" && !selectedTemplateId) {
      errorsCopy.savedTemplate = t("form.errors.emptySelection", {
        field: t("contracts.savedTemplate"),
      });
      isValid = false;
    } else {
      delete errorsCopy["savedTemplate"];
    }
    if (!BasicDetailsCopy.Date) {
      errorsCopy.Date = t("form.errors.emptyField", {
        field: t("contracts.dateContract"),
      });
      isValid = false;
    } else if (
      !moment(BasicDetailsCopy.Date).isSameOrAfter(moment(new Date()), "day")
    ) {
      errorsCopy.Date = t("form.errors.pastDate");
      isValid = false;
    } else {
      delete errorsCopy["Date"];
    }

    if (!BasicDetailsCopy.BusinessLegalName?.trim()) {
      errorsCopy.BusinessLegalName = t("form.errors.emptyField", {
        field: t("contracts.businessLegalName"),
      });
      isValid = false;
    } else if (
      BasicDetailsCopy.BusinessLegalName &&
      BasicDetailsCopy.BusinessLegalName?.trim()?.length > 80
    ) {
      errorsCopy.BusinessLegalName = t("form.errors.maxLimit", { limit: "80" });
      isValid = false;
    } else {
      delete errorsCopy["BusinessLegalName"];
    }

    if (!BasicDetailsCopy.Position?.trim()) {
      errorsCopy.Position = t("form.errors.emptyField", {
        field: t("contracts.position"),
      });
      isValid = false;
    } else if (
      BasicDetailsCopy.Position &&
      BasicDetailsCopy.Position?.trim()?.length > 100
    ) {
      errorsCopy.Position = t("form.errors.maxLimit", { limit: "100" });
      isValid = false;
    } else {
      delete errorsCopy["Position"];
    }

    if (!BasicDetailsCopy.OfficeAddress?.trim()) {
      errorsCopy.OfficeAddress = t("form.errors.emptyField", {
        field: t("form.fields.officeAddress"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.OfficeAddress?.trim()?.length > 200) {
      errorsCopy.OfficeAddress = t("form.errors.maxLimit", { limit: "200" });
      isValid = false;
    } else {
      delete errorsCopy["OfficeAddress"];
    }

    if (!BasicDetailsCopy.LengthOfEmployment?.trim()) {
      errorsCopy.LengthOfEmployment = t("form.errors.emptyField", {
        field: t("contracts.lengthEmployment"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.LengthOfEmployment?.trim()?.length > 36) {
      errorsCopy.LengthOfEmployment = t("form.errors.maxLimit", {
        limit: "36",
      });
      isValid = false;
    } else {
      delete errorsCopy["LengthOfEmployment"];
    }

    if (!BasicDetailsCopy.StartOfWorkDate) {
      errorsCopy.StartOfWorkDate = t("form.errors.emptyField", {
        field: t("contracts.startWork"),
      });
      isValid = false;
    } else {
      delete errorsCopy["StartOfWorkDate"];
    }

    if (
      BasicDetailsCopy.EndOfWorkDate &&
      moment(BasicDetailsCopy.EndOfWorkDate).isBefore(
        moment(BasicDetailsCopy.StartOfWorkDate),
      )
    ) {
      errorsCopy.EndOfWorkDate = t("form.errors.endDate");
      isValid = false;
    } else {
      delete errorsCopy["EndOfWorkDate"];
    }

    if (!BasicDetailsCopy.EmployeeName?.trim()) {
      errorsCopy.EmployeeName = t("form.errors.emptyField", {
        field: t("contracts.employeeName"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.EmployeeName?.trim()?.length > 50) {
      errorsCopy.EmployeeName = t("form.errors.maxLimit", { limit: "50" });
      isValid = false;
    } else {
      delete errorsCopy["EmployeeName"];
    }

    if (!BasicDetailsCopy.EmployeeAddress?.trim()) {
      errorsCopy.EmployeeAddress = t("form.errors.emptyField", {
        field: t("contracts.employeeAddress"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.EmployeeAddress?.trim()?.length > 200) {
      errorsCopy.EmployeeAddress = t("form.errors.maxLimit", { limit: "200" });
      isValid = false;
    } else {
      delete errorsCopy["EmployeeAddress"];
    }

    if (!BasicDetailsCopy.Salary?.trim()) {
      errorsCopy.Salary = t("form.errors.emptyField", {
        field: t("contracts.salaryFeeWage"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.Salary?.trim()?.length > 100) {
      errorsCopy.Salary = t("form.errors.maxLimit", { limit: "100" });
      isValid = false;
    } else {
      delete errorsCopy["Salary"];
    }
    if (BasicDetailsCopy?.commission?.trim()?.length > 300) {
      errorsCopy.commission = t("form.errors.maxLimit", { limit: "300" });
      isValid = false;
    } else {
      delete errorsCopy["commission"];
    }
    if (BasicDetailsCopy?.bonus?.trim()?.length > 300) {
      errorsCopy.bonus = t("form.errors.maxLimit", { limit: "300" });
      isValid = false;
    } else {
      delete errorsCopy["bonus"];
    }
    seterrors(errorsCopy);
    return isValid;
  };

  const renderForm = (step) => {
    switch (step) {
      case 0:
        return (
          <StepOne
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={setBasicDetails}
            errors={errors}
            setFormDetails={setFormDetails}
            setisSavedTemplate={setisSavedTemplate}
            handleSwitch={handleSwitch}
            savedTemplate={isSavedTemplate}
            fetchTemplateData={fetchTemplateData}
            selectedTemplateId={selectedTemplateId}
          />
        );
      case 1:
        return (
          <StepTwo
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 2:
        return (
          <StepThree
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 3:
        return (
          <StepFour
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            fieldList={fieldList}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 4:
        return (
          <StepFive
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 5:
        return (
          <StepSix
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            fieldList={fieldList}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      default:
      // do nothing
    }
  };
  const renderNav = (show) =>
    show && (
      <>
        <div>
          <button
            className="button button-round button-border button-dark"
            style={
              buttonsState.showPreviousBtn
                ? props.prevStyle
                : { display: "none" }
            }
            onClick={previous}
          >
            {t("contracts.previousStep")}
          </button>
        </div>

        <div className="next-step-col">
          <div
            className="link-btn cancel-btn"
            onClick={() => {
              setModalIsOpen(true);
            }}
          >
            {t("cancel")}
          </div>
          <button
            className="button button-round button-shadow"
            style={
              !previewContract && buttonsState.showNextBtn
                ? props.nextStyle
                : { display: "none" }
            }
            onClick={next}
          >
            {t("contracts.nextStep")}
          </button>

          <button
            className="button button-round button-shadow"
            style={
              !previewContract && buttonsState.showCompleteBtn
                ? props.completeStyle
                : { display: "none" }
            }
            onClick={next}
          >
            {t("contracts.reviewEmploymentContract")}
          </button>
          <button
            className="button button-round button-shadow mr-4"
            style={previewContract ? props.completeStyle : { display: "none" }}
            onClick={() => {
              setConfirmExportModal(true);
            }}
          >
            {t("contracts.exportEmploymentContract")}
          </button>
          <button
            className="button button-round button-shadow"
            style={previewContract ? props.completeStyle : { display: "none" }}
            onClick={() => {
              setConfirmSentModal(true);
            }}
          >
            {t("contracts.sendEmploymentContract")}
          </button>
        </div>
      </>
    );

  const saveDraftContract = async (submit) => {
    setConfirmSentModal(false);
    setPdfLoader(true);
    try {
      const formData = { ...BasicDetails };
      formData.IsSubmitted = !submit;
      ["Date", "StartOfWorkDate", "EndOfWorkDate"].forEach((key) => {
        if (formData[key]) {
          formData[key] = moment(formData[key]).format("YYYY-MM-DD");
        }
      });
      formData.ContractDetails = normalizeContractDetailsDatesForApi(
        formData.ContractDetails,
      );
      Object.keys(formData).forEach((key) => {
        if (typeof formData[key] === "string") {
          formData[key] = formData[key]?.trim();
        }
      });
      if (contractId !== 0) {
        delete formData["staffId"];
        formData["contractId"] = contractId;
        await editContractMutation.mutateAsync(formData);
      } else {
        const resp = await uploadContractMutation.mutateAsync(formData);
        setContractId(resp.id);
      }
      setModalIsOpen(false);
      toast.success(t("contracts.contractUploadedSuccessfully"));
      setShowPrompt(false);
      if (submit) {
        exitForm();
      } else {
        setSaveContractTemplateModal(true);
      }
    } catch (e) {
      toast.error(e.message);
      setModalIsOpen(false);
    } finally {
      setPdfLoader(false);
    }
  };

  const getContractList = () => {
    let fields = [];
    const contractDetailsList =
      BasicDetails.ContractDetails || contractTemplateData;
    if (contractDetailsList) {
      if (isPerSonnelType) {
        contractDetailsList.forEach((e) => {
          if (e.isMainSection) {
            fields.push(e);
            setfieldList(fields);
          }
        });
      } else {
        let contractData = [...contractDetailsList];
        contractData.reverse();
        const lastElemStepOne = contractData.find(
          (x) => x.stepNumber === 1 && x.isMainSection,
        );
        const lastElemStepTwo = contractData.find((x) => x.stepNumber === 2);
        const lastElemStepThree = contractData.find((x) => x.stepNumber === 5);
        const lastElemStepFour = contractData.find(
          (x) => x.stepNumber === 6 && x.isHtmlContent,
        );
        if (lastElemStepOne)
          lastElemStepOne.title = t("contracts.ownerAndTheAssociateAgree");
        if (lastElemStepTwo)
          lastElemStepTwo.title = t("contracts.theOwnerAgree");
        if (lastElemStepThree)
          lastElemStepThree.title = t("contracts.theAssociateAgree");
        if (lastElemStepFour) lastElemStepFour.title = t("contracts.general");
        setfieldList([
          lastElemStepOne,
          lastElemStepTwo,
          lastElemStepThree,
          lastElemStepFour,
        ]);
      }
    }
  };

  const exitForm = () => {
    setShowPrompt(false);
    setTimeout(() => {
      history.push(
        constants.routes.accountOwner.staffContracts
          .replace(":officeId", encodeId(officeId))
          .replace(":staffId", encodeId(staffId)),
      );
    }, 30);
  };

  const removeHtmlChar = (html) => {
    return stripHtml(html);
  };

  let timeout = null;

  const setFormDetails = (index, value, debounce = false) => {
    let newArr = cloneDeep(stateRef.current.ContractDetails);
    let item = cloneDeep(newArr[index]);
    if (item) {
      if (value instanceof Date) {
        value = moment(value).format("DD-MM-YYYY");
      }
      const htmlChar = removeHtmlChar(value);
      if (htmlChar?.length == 0 || htmlChar?.length > maxLimitReach) {
        if (htmlChar?.length > maxLimitReach && item.isHtmlContent) {
          item.error = t("form.errors.maxLimit", {
            limit: maxLimitReach.toString(),
          });
        } else if (htmlChar?.length === 0&&item.title!=="Date") {
          item.error = t("form.errors.emptyField", { field: item.title });
        }
      } else {
        delete item["error"];
      }
      if (typeof item.text === "string") {
        const matches =
          item.text.match(/\[(.*?)\]/g)?.map((m) => m.slice(1, -1)) || [];
        if (matches.length) {
          matches.forEach((res) => {
            const findKey = replaceableValue.find(
              (resp) => resp.text === `[${res}]`,
            );
            if (findKey?.key) {
              const valueInObject = stateRef.current[findKey.key];
              if (valueInObject) {
                let markwillbeplaceHolder;
                if (stateRef.current[findKey.key] instanceof Date) {
                  markwillbeplaceHolder = moment(
                    stateRef.current[findKey.key],
                  ).format("DD-MM-YYYY");
                } else {
                  markwillbeplaceHolder = stateRef.current[findKey.key]?.trim();
                }
                value = replaceAll(value, markwillbeplaceHolder, `[${res}]`);
              }
            }
          });
        }
      }
      item.text = value;
      newArr[index] = item;
      stateRef.current = { ...stateRef.current, ContractDetails: newArr };
      if (debounce) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          setBasicDetails({ ...stateRef.current, ContractDetails: newArr });
        }, 300);
      } else {
        setBasicDetails({ ...stateRef.current, ContractDetails: newArr });
      }
    }
  };

  const handleSwitch = (index, status) => {
    let newArr = [...stateRef.current.ContractDetails];
    if (newArr[index]) {
      newArr[index].isActive = status;
      newArr[index].text = newArr[index].text.substring(0, 995);
      delete newArr[index]["error"];
      setBasicDetails({ ...stateRef.current, ContractDetails: newArr });
      getContractList();
    }
  };

  const exportContract = async () => {
    setConfirmExportModal(false);
    setPdfLoader(true);
    let formData = {
      ...BasicDetails,
    };
    formData.IsSubmitted = false;
    ["Date", "StartOfWorkDate", "EndOfWorkDate"].forEach((key) => {
      if (formData[key]) {
        formData[key] = moment(formData[key]).format("YYYY-MM-DD");
      }
    });
    formData.ContractDetails = normalizeContractDetailsDatesForApi(
      formData.ContractDetails,
    );
    Object.keys(formData).forEach((key) => {
      if (typeof formData[key] === "string") {
        formData[key] = formData[key]?.trim();
      }
    });
    try {
      let resp;
      if (contractId) {
        delete formData["staffId"];
        formData["contractId"] = contractId;
        resp = await editContractMutation.mutateAsync(formData);
      } else {
        resp = await uploadContractMutation.mutateAsync(formData);
      }
      if (resp) {
        if (contractId) {
          downloadPdf(contractId);
        } else {
          downloadPdf(resp.id);
          setContractId(resp.id);
        }
        let newArr = [...resp.contractDetails];
        newArr = newArr.map((e) => {
          if (
            e.title === "Authorised Signature" &&
            !!e.text &&
            e.text.split(
              `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/`,
            )[1]
          ) {
            e.text =
              `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/` +
              e.text.split(
                `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/`,
              )[1];
          }
          return e;
        });
        setBasicDetails({ ...BasicDetails, ContractDetails: newArr });
      }
    } catch (e) {
      toast.error(e.message);
      setPdfLoader(false);
    }
  };

  const downloadPdf = async (id) => {
    try {
      const resp = await getContractTemplatePdf(id);
      if (resp) {
        const blob = b64toBlob(resp, "application/pdf");
        if (isMobileTab()) {
          FileSaver.saveAs(blob);
        } else {
          const blobUrl = URL.createObjectURL(blob);
          const pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" +
              blobUrl +
              "'></iframe>",
          );
          pdfWindow.document.close();
        }
      }
      setPdfLoader(false);
    } catch (e) {
      setPdfLoader(false);
    }
  };
  const saveContractTemplate = async (Name) => {
    setPdfLoader(true);
    try {
      const values = getCacheLocalstorage(
        constants.contracts.contractslocalstorageKey,
        true,
      );

      const formData = {
        contractId,
        officeId,
        TemplateType: +designationType,
        OwnerId: values?.ownerId,
        Name,
      };
      await contractTemplateMutation.mutateAsync(formData);
      setSaveContractTemplateModal(false);
      toast.success(t("contracts.templateSavedSuccessfully"));
      exitForm();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setPdfLoader(false);
    }
  };
  return (
    <Fragment>
      {pdfLoader && <Loader />}

      {previewContract ? (
        isPerSonnelType ? (
          <PreviewPersonnelContract
            officeDetail={officeDetail}
            contractData={BasicDetails}
            contractFormDisplayData={contractFormDisplayData}
            isEdit={false}
          />
        ) : (
          <PreviewAssociateContract
            officeDetail={officeDetail}
            contractData={BasicDetails}
            contractFormDisplayData={contractFormDisplayData}
            isEdit={false}
          />
        )
      ) : (
        <div className="multi-step-form ">
          <ol className="steps-tracker">{renderSteps()}</ol>
          <div className="form-body">{renderForm(compState)}</div>
        </div>
      )}
      <div className="prev-next-buttons">{renderNav(showNav)}</div>

      {modalIsOpen && (
        <CancelContractModal
          isModalOpen={modalIsOpen}
          saveDraft={() => saveDraftContract(true)}
          closeModal={() => {
            setModalIsOpen(false);
          }}
          exitForm={exitForm}
        />
      )}
      {confirmSentModal && (
        <ConfirmContractModal
          isModalOpen={confirmSentModal}
          sendContract={() => saveDraftContract(false)}
          closeModal={() => {
            setConfirmSentModal(false);
          }}
        />
      )}
      {confirmExportModal && (
        <ExportContractModal
          isModalOpen={confirmExportModal}
          saveDraft={() => exportContract()}
          closeModal={() => {
            setConfirmExportModal(false);
          }}
        />
      )}

      {saveContractTemplateModal && (
        <SaveTemplateModal
          isModalOpen={saveContractTemplateModal}
          saveContractTemplate={saveContractTemplate}
          closeModal={() => {
            exitForm();
          }}
        />
      )}
    </Fragment>
  );
}
export default withTranslation()(AddContract);
